import { render } from "./NavigationPopupSideComponent.vue?vue&type=template&id=71a317d1"
import script from "./NavigationPopupSideComponent.vue?vue&type=script&lang=js"
export * from "./NavigationPopupSideComponent.vue?vue&type=script&lang=js"
script.render = render

export default script